module.exports = __webpack_public_path__ + "static/Lato-Bold-24b516c266d7341c954cb2918f1c8f38.ttf";